"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrice = void 0;
function isPrice(value) {
    return (typeof value.name === 'string' &&
        typeof value.price === 'number' &&
        typeof value.color === 'string' &&
        typeof value.description === 'string' &&
        value.price >= 0);
}
exports.isPrice = isPrice;
